enum MenuBuilderTab {
  MENUS = 'menus',
  ITEMS_AND_MODS = 'items-and-mods',
  ITEM_GROUPS = 'item-groups',
  MOD_GROUPS = 'mod-groups',
}

export default MenuBuilderTab;
